import { useEffect } from "react";
import { Form } from "antd";
import { useAtom } from "jotai";
import { frmPreguntasPredisposicionAtom, puntajeTotalPredisposicionAtom } from "../../BandejaEvaluacionStorage";

const usePreguntasPredisposicion = () => {
	const [puntajeTotal, setPuntajeTotal] = useAtom(puntajeTotalPredisposicionAtom);
	const [frmPreguntas, setFrmPreguntas] = useAtom(frmPreguntasPredisposicionAtom);
	const [form] = Form.useForm();

	useEffect(() => {
		if (!frmPreguntas) {
			setFrmPreguntas(form);
		}
	}, []);

	return { frmPreguntas, puntajeTotal, setPuntajeTotal };
};

export default usePreguntasPredisposicion;
